<template>
  <div>
    <!-- 上传附件 -->
    <el-upload
      class="avatar-uploader2"
      :action="action"
      :headers="gettoken()"
      :on-success="handleAvatarSuccess"
      :on-remove="handleAvatarRemove"
      :limit='1'
      accept=".doc,.docx,.xls,.xlxs,.zip,.pdf"
      :file-list="fileListHt"
      :before-upload="beforeAvatarUpload"
      :on-preview="previewAvatar"
      :disabled="disabled">
      <el-button size="mini" type="primary" :disabled="disabled">上传文件</el-button>
      <!-- <div slot="tip" class="el-upload__tip" style="color:#7a7a7a;position:absolute;left: 90px;top:4px;">可上传doc、docx、xls、xlxs、pdf文件</div> -->
      <!-- accept=".doc,.docx,.xls,.xlxs,.rar,.zip,.pdf,.jpg,.png" -->
    </el-upload>
  </div>
</template>

<script>
import axios from 'axios'
import config from '@/api/config'
export default {
  name: 'BoyoUploadThree',
  props: {
    action: String,
    src: String,
    value: String,
    fileListHt: Array,
    disabled: Boolean
  },
  data () {
    return {
    }
  },
  mounted () {

  },
  methods: {
    gettoken () {
      let Token = JSON.parse(localStorage.token).value
      let loginTissueId = localStorage.loginTissueId
      return { Token: Token,'X-Tissue-Id': loginTissueId}
    },
    myUpload (content) {
      axios({
        method: 'post',
        url: content.action,
        data: content.file
      }).then(res => {
        content.onSuccess(res.data)
      })
    },
    beforeAvatarUpload (file) {
    },
    previewAvatar(file) { // 查看
      let url = ''
      if(file.response && file.response.data){
        url = file.response.data
      } else if(file.url){
        url = file.url
      }
      
      if(url){
        // 如果已经是完整URL，直接使用；否则拼接基础URL
        if(url.startsWith('http://') || url.startsWith('https://')){
          window.open(url)
        } else {
          window.open(config.pingImgUrl + url)
        }
      }
    },
    handleAvatarSuccess (res, file, fileList) {
      this.$emit('on-success', res, file, fileList, this.value)
    },
    handleAvatarRemove (file, fileList) {
      this.$emit('on-remove', file, fileList, this.value)
    }
  }
}
</script>
<style lang="stylus" scoped>
.avatar-uploader>>> .el-upload
  border 1px dashed #d9d9d9
  border-radius 6px
  cursor pointer
  position relative
  overflow hidden
.avatar-uploader>>> .el-upload:hover
  border-color #409EFF
.avatar-uploader-icon
  font-size 28px
  color #8c939d
  width 85px
  height 85px
  line-height 85px
  text-align center
.avatar
  width 85px
  height 85px
  display block
.avatar-uploader2
  cursor pointer
</style>



// WEBPACK FOOTER //
// src/components/BoyoUploadThree/index.vue